import React from "react"

import {CoverPosition} from "../../../model2/task/properties/cover"
import PopoverMenuOption from "../../popover-menu/popover-menu/menu-option"

type Props = {
    menuParams  : {
        position            : CoverPosition,
        onPositionSelected  : {(value: CoverPosition): void}
    }
    hidePopover : callback
}

export default function CoverPositionMenu(props:Props) {
    const options = [{
        id      : CoverPosition.TOP,
        label   : "Top",
        onClick : ()=>{
            props.hidePopover()
            props.menuParams.onPositionSelected && props.menuParams.onPositionSelected(CoverPosition.TOP)
        }
    }, {
        id      : CoverPosition.MIDDLE,
        label   : "Middle",
        onClick : ()=>{
            props.hidePopover()
            props.menuParams.onPositionSelected && props.menuParams.onPositionSelected(CoverPosition.MIDDLE)
        }
    }, {
        id      : CoverPosition.BOTTOM,
        label   : "Bottom",
        onClick : ()=>{
            props.hidePopover()
            props.menuParams.onPositionSelected && props.menuParams.onPositionSelected(CoverPosition.BOTTOM)
        }
    }]

    return (
        <div className="ui5-popover-menu">
            {_.map(options, option=>
                <PopoverMenuOption key          = {option.id}
                                   option       = {option}
                                   isSelected   = {option.id === props.menuParams.position}/>
            )}
        </div>
    )
}